import { Locale } from 'modules/i18n';

export default {
  [Locale.en]: {
    submit: 'Continue',
    title: 'Payment',
    accountFunds: 'Account Funds',
    deposit: 'Deposit',
    depositValue: '{balance} {unit}',
    description:
      'Ankr Guardian balance shares to all tasks except self paid tasks. So if you change number of tasks payed by Ankr Guardians Balance, remaining tasks estimation can also change.',
  },
};
